// extracted by mini-css-extract-plugin
module.exports = {"loader_spinner":"loader_spinner-3VxzT","rotation":"rotation-3m0Bj","loader":"loader-16k87","loader__content":"loader__content-jZmlM"};